import React, { useEffect, useState } from "react";
import { BACKEND_URL } from "@/lib/backendUrl";
import { Link } from "react-router-dom";
import axios from "axios";
import { TrendingUp, Flame } from "lucide-react";

const API = `${BACKEND_URL}/api`;

/**
 * Mini trending strip in the Studio — shows the top 3 sets right now
 * so active DJs discover peers while they mix.
 */
export default function StudioTrending() {
  const [sets, setSets] = useState([]);
  useEffect(() => {
    axios.get(`${API}/sets/trending`).then(r => setSets(r.data.slice(0, 3))).catch(() => {});
  }, []);
  if (sets.length === 0) return null;
  return (
    <div className="border-y border-[#1E2638] bg-[#0B0E14]/95 backdrop-blur-md px-4 py-2 relative z-30" data-testid="studio-trending-strip">
      <div className="flex items-center gap-3 max-w-[1920px] mx-auto">
        <div className="flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-widest text-[#FF2A6D] flex-shrink-0">
          <TrendingUp className="w-3 h-3"/> Trending
        </div>
        <div className="flex items-center gap-2 overflow-x-auto flex-1">
          {sets.map((s, i) => (
            <Link key={s.id} to={`/set/${s.id}`} data-testid={`studio-trending-${s.id}`}
              className="flex-shrink-0 flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#1E2638] hover:border-[#FF2A6D] hover:bg-[#FF2A6D]/5 text-xs whitespace-nowrap transition-colors">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00F0FF] to-[#FF2A6D] font-black">#{i + 1}</span>
              <span className="text-white font-bold">{s.name}</span>
              <span className="text-[#94A3B8]">by {s.artist_name}</span>
              <span className="flex items-center gap-1 text-[#FF8C00] font-mono">
                <Flame className="w-3 h-3"/> {s.reaction_count || 0}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
